/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




function convertToMoney(x) {
    return Number.parseFloat(x).toFixed(2);
}
Number.prototype.formatMoney = function(sign, num, comma, t) {
    var n = this,
        num = isNaN(num = Math.abs(num)) ? 2 : num,
        comma = comma == undefined ? "," : comma,
        t = t == undefined ? "." : t,
        sign = sign == undefined ? '$' : sign;
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(num))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    return sign + s + (j ? i.substr(0, j) + comma : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + comma) + (num ? t + Math.abs(n - i).toFixed(num).slice(2) : "")
};
  
  
function push(list, items) {
    Array.prototype.push.apply(list, items);
    list.length_ = list.length;
    list.length_ += items.length;
}
  
  
function getStyle(oElm, strCssRule){
    var strValue = "";
    if (document.defaultView && document.defaultView.getComputedStyle){
      strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
    } else if(oElm.currentStyle){
      strCssRule = strCssRule.replace(/\-(\w)/g, function (strMatch, p1){
        return p1.toUpperCase();
      });
      strValue = oElm.currentStyle[strCssRule];
    }
    return strValue;
}
  
  
Date.prototype.addDays = function (d) {
    if (d) {
      var t = this.getTime();
      t = t + (d * 86400000);
      // this.setTime(t);
      // new Date(minDays).toLocaleDateString("en-US");
      return this.setTime(t);
    }
};
  
function nextweek(){
    var today = new Date();
    var nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate()+7);
    return nextweek;
}
function plusDays(d){
    if (d) {
      var today = new Date();
      var nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + d);
      return nextweek;
    }
}
  
const dateOptions = { day: 'numeric', month: 'numeric' };
Date.prototype.getMonthName = function(lang) {
    lang = lang && (lang in Date.locale) ? lang : 'en';
    return Date.locale[lang].month_names[this.getMonth()];
};
  
Date.prototype.getMonthNameShort = function(lang) {
    lang = lang && (lang in Date.locale) ? lang : 'en';
    return Date.locale[lang].month_names_short[this.getMonth()];
};
  
Date.locale = {
    en: {
      month_names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      month_names_short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
};
  
function getShortYear(d) {
    var shortYear = d.getFullYear(); 
    return shortYear.toString().substr(-2);
    // return twoDigitYear;
}
  
  
const getPopupCookie = name => {
    const nameExpression = `${name}=`;
    const cookies = document.cookie.split(';');
    const cookie = cookies.find(currentCookie => currentCookie.includes(nameExpression));  
    return cookie ? cookie.trim().substring(nameExpression.length, cookie.length) : null;
}
const setPopupCookie = (name, value, expire = 90, path = '/') => {
    const date = new Date();
    date.setTime(date.getTime() + (expire * 24 * 3600 * 1000));
    const expires = date.toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=${path}`;
};
  
  
  
  // let lcp;
  // const po = new PerformanceObserver((eList) => {
  //   const e = eList.getEntries();
  //   const last = e[e.length - 1];
  //   lcp = last.renderTime || last.loadTime;
  //   for (const entry of e) {
  //     console.log('LCP candidate:', entry.startTime, entry);
  //   }
  // });
  
  // const poOpts = {
  //   type: 'largest-contentful-paint',
  //   buffered: true
  // }
  // po.observe(poOpts);
  
new PerformanceObserver((entryList) => {
    for (const entry of entryList.getEntries()) {
      console.log('LCP candidate:', entry.startTime, entry);
    }
}).observe({type: 'largest-contentful-paint', buffered: true})
  
new PerformanceObserver((entryList) => {
    for (const entry of entryList.getEntries()) {
      if (!entry.hadRecentInput) {
        console.log("LayoutShift value:", entry.value);
        if (entry.sources) {
          for (const { node, currentRect, previousRect } of entry.sources)
            console.log("LayoutShift source:", node, {
              currentRect,
              previousRect,
            });
        }
      }
    }
}).observe({ type: "layout-shift", buffered: true });
  
  
  
  






// (function() {
//   var script = document.createElement('script');
//   script.src = 'https://unpkg.com/web-vitals@3/dist/web-vitals.iife.js';
//   script.onload = function() {
//     // When loading `web-vitals` using a classic script, all the public
//     // methods can be found on the `webVitals` global namespace.
//     webVitals.onCLS(console.log(webVitals));
//     webVitals.onFID(console.log);
//     webVitals.onLCP(console.log(webVitals));
//   }
//   document.head.appendChild(script);
// }())
const quickShipValues = ['5 to 7 Days', '5 to 10 Days', '10 Days', '1 to 2 Weeks', '1 to 3 Weeks', '2 to 3 Weeks', '2 to 4 Weeks', '3 to 4 Weeks'];
const inStockValues = ['4 to 6 Weeks'];
const madeToOrder = 'Made to Order';
const quickShipText = "Quick Ship";

const shadeQuickShipValues = ['4 to 5 Weeks'];

// document.addEventListener('searchspring.domReady', function(event) {
//   console.log(event);
//   document.getElementById('skeleton-container').style.display = 'none';
// });




const quickShipLabel = document.getElementById('quick-ship-label');
const quickShipIconArea = document.getElementById('quick-ship-image-label');
const quickShipTableIcon = document.getElementById('quick-ship-cell');

const arrival = document.getElementById('arrival');
// const leadTimeNote = document.getElementById('lead_time_note');
// const leadTimeNoteItems = document.querySelectorAll('.lead_time_note');

const CUSTOM_COLOR_VENDORS = ['Playground Equipment', 'Henderson', 'Wisdom', 'World Klass Play'];
const PE_COLOR_KEYWORDS = ['custom', 'double row', 'single row', 'pod climber'];
const PE_NON_COLOR_KEYWORDS = ['primary', 'neutral', 'natural', 'rainforest green', 'pacific blue'];
  
const setOptionVisibility = (els, show) => {
    els.forEach((el) => {
      el.style.display = show ? 'flex' : 'none';
      const select = el.querySelector('select');
      if (select) select.disabled = !show;
    });
}
  
const toggleVisibility = (element, condition, input = null) => {
    if (!element) return;
    element.classList.toggle('hidden', !condition);
    if (input) {
      input.checked = condition;
      if (!condition) input.remove();
    }
};
  
function titleHas(title, keywords) {
    const titleLC = title.toLowerCase();
    return keywords.some((k) => titleLC.includes(k));
}
  
  
// ===== Custom color options: single source of truth =====
// Both the 'variant:changed' event (fires on every selection change) and the
// Shoppad "infiniteoptions" app's ready callback (fires once, when that app
// mounts on page load) need to show/hide the exact same custom-color pickers,
// for the exact same reasons. They used to carry two separate, drifting
// copies of this logic. Everything below is resolved once and called from
// both places so they can't disagree about what should be visible.

const GALVANIZED_STAINLESS_KEYWORDS = ['galvanized', 'stainless', 'powder coated'];
  
function getCurrentVendor() {
  // console.log('getCurrentVendor', window.currentProduct);
  return window.currentProduct ? window.currentProduct.vendor : document.querySelector('.product-meta__vendor')?.textContent?.trim();
  // return document.querySelector('.product-meta__vendor')?.textContent?.trim();
}
  
  // Lower-cased variant title, used to key every vendor color rule below. Prefer
  // a real variant object - the one passed by the 'variant:changed' event, or
  // window.currentVariant once the page/Shoppad has loaded - since its title is
  // the authoritative combination of every selected option. Only fall back to
  // reading the on-page selects/swatches directly if neither is available yet.
function getSelectionTitleLC(variant, productForm) {
  const title = (variant || window.currentVariant || {}).title;
  if (title) return title.toLowerCase();

  if (!productForm) return '';
  const parts = [];
  productForm.querySelectorAll('.product-form__single-selector').forEach((select) => {
    const opt = select.options[select.selectedIndex];
    if (opt) parts.push(opt.value || opt.textContent);
  });
  const colorSwatch = productForm.querySelector('.color-swatch__radio:checked');
  if (colorSwatch) parts.push(colorSwatch.value);
  return parts.join(' / ').toLowerCase();
}
  
  // SportsPlay: the custom color pickers only apply to the "Custom" color variant.
function syncSportsPlayColors(infiniteContainer, titleLC) {
    const sportplayColors = infiniteContainer.querySelectorAll('.sportplay-color');
    if (!sportplayColors.length) return;
    const isCustom = titleLC.includes('custom');
    sportplayColors.forEach((color_el) => {
      color_el.style.display = isCustom ? 'flex' : 'none';
      const select = color_el.getElementsByTagName('select')[0];
      if (select) select.required = isCustom;
    });
}
  
  // Galvanized override, shared by SportsPlay + UltraPlay-style powder-coat color
  // pickers: picking a galvanized finish clears any already-chosen color/powder-
  // coat property, hides the picker, and injects a hidden "none" radio so the
  // property still submits with the order.
function syncGalvanizedColorOverride(infiniteContainer, isGalvanized) {
    const ultraplayColors = infiniteContainer.querySelector('.ultraplay-colors');
    if (!ultraplayColors) return;
  
    toggleVisibility(ultraplayColors, !isGalvanized);
    const galvInput = document.getElementById('infinite-galvanized');
  
    if (isGalvanized) {
      ['properties[powder_coating_color]', 'properties[color]'].forEach((name) => {
        document.querySelectorAll(`[name="${name}"]`).forEach((el) => {
          if (el.type === 'radio' || el.type === 'checkbox') el.checked = false;
          else if (el.tagName === 'SELECT') el.selectedIndex = 0;
        });
      });
  
      if (!galvInput) {
        const galv = document.createElement('input');
        galv.type = 'radio';
        galv.name = 'properties[powder_coating_color]';
        galv.id = 'infinite-galvanized';
        galv.value = 'none';
        galv.checked = true;
        ultraplayColors.appendChild(galv);
      } else {
        galvInput.checked = true;
      }
    } else {
      galvInput?.remove();
    }
}
  
  // Playground Equipment family (PE, Henderson, Wisdom, World Klass Play).
function syncPeFamilyColors(infiniteContainer, vendor, titleLC) {
    if (!CUSTOM_COLOR_VENDORS.includes(vendor)) return;
    const isGalvanizedOrStainless = titleHas(titleLC, GALVANIZED_STAINLESS_KEYWORDS);
    if (!isGalvanizedOrStainless) {
      const shouldDisplay = titleHas(titleLC, PE_COLOR_KEYWORDS);
      // console.log('shouldDisplay', shouldDisplay);
      setOptionVisibility(infiniteContainer.querySelectorAll('.pe_color'), shouldDisplay);
      if (!PE_NON_COLOR_KEYWORDS.some((k) => titleLC.includes(k))) {
        setOptionVisibility(infiniteContainer.querySelectorAll('.pe_color'), true);
      }
    }
    if (vendor !== 'Playground Equipment') return;
  
    const isGalvanized = titleLC.includes('galvanized');
    setOptionVisibility(infiniteContainer.querySelectorAll('.pe_color_zero'), !isGalvanized);
    // Sit-n-Spin: a handful of colors never show the custom color picker,
    // regardless of the "custom" / "double row" etc. keyword rule above.
    if (window.location.pathname === '/products/sit-n-spin') {
      const hideColors = ['yellow', 'red', 'tan', 'pacific blue'];
      if (hideColors.some((c) => titleLC.includes(c))) {
        setOptionVisibility(infiniteContainer.querySelectorAll('.pe_color'), false);
      }
    }
}
  
  // Ultra Play Premier: the roof/shade color pickers only show when that add-on
  // is actually part of the selected variant.
function syncUltraPlayPremierColors(infiniteContainer, vendor, titleLC) {
    if (vendor !== 'Ultra Play Premier') return;
    const roofColorSelect = infiniteContainer.querySelector('.roof-colors');
    const shadeColorSelect = infiniteContainer.querySelector('.shade-colors');
    if (roofColorSelect) setOptionVisibility([roofColorSelect], titleLC.includes('with roof'));
    if (shadeColorSelect) setOptionVisibility([shadeColorSelect], titleLC.includes('with shade'));
}
  
  // Single entry point - call this from both the 'variant:changed' handler and
  // Shoppad's ready callback so every trigger applies the exact same rules.
function syncColorOptions(variant, productForm, infiniteContainer = document.getElementById('infiniteoptions-container')) {
    if (!infiniteContainer) return;
  
    const vendor = getCurrentVendor();
    const titleLC = getSelectionTitleLC(variant, productForm);
  
    syncSportsPlayColors(infiniteContainer, titleLC);
    syncGalvanizedColorOverride(infiniteContainer, titleLC.includes('galvanized'));
    syncPeFamilyColors(infiniteContainer, vendor, titleLC);
    syncUltraPlayPremierColors(infiniteContainer, vendor, titleLC);
}



const checkSelectsForCustomOptions = () => {
  const selects = document.querySelectorAll('.product-form__single-selector');
  if (!selects.length) return;

  // ZERO STILL
  const checkZeroStill = function () {
    const selectedModelSelect = document.querySelector('#option-model');
    if (!selectedModelSelect) return;
    const pePostColor = document.querySelector('.pe_color_zero');
    const isGalvanized = selectedModelSelect.value.toLowerCase().includes('galvanized');
    pePostColor ? toggleVisibility(pePostColor, !isGalvanized) : null;
    pePostColor ? pePostColor.querySelector('select').disabled = isGalvanized : null;
  }

  const checkPZSSeries = function () {
    const selectedPostSelect = document.querySelector('#option-post');
    if (!selectedPostSelect) return;
    const pePostColor = document.querySelector('.pe_color_zero');
    const isGalvanized = selectedPostSelect.value.toLowerCase().includes('galvanized');
    pePostColor ? toggleVisibility(pePostColor, !isGalvanized) : null;
    pePostColor ? pePostColor.querySelector('select').disabled = isGalvanized : null;
  }

  const checkNetPlayRopeSelects = function () {
    const ropeGaugeSelect = document.querySelector('#option-rope_gauge');
    if (!ropeGaugeSelect) return;
  
    const ropeColorOptionsSelect16mm = document.querySelector('.rope-color-options');
    const ropeColorOptionsSelect18mm = document.querySelector('.rope-color-18mm');
    
    if (ropeColorOptionsSelect16mm && ropeColorOptionsSelect18mm) {
      const is18mm = ropeGaugeSelect.value === '18 MM';
      // ropeColorOptionsSelect16mm.classList.toggle('hidden', is18mm);
      toggleVisibility(ropeColorOptionsSelect16mm, !is18mm);
      ropeColorOptionsSelect16mm.querySelector('select').disabled = is18mm;
      // ropeColorOptionsSelect18mm.classList.toggle('hidden', !is18mm);
      toggleVisibility(ropeColorOptionsSelect18mm, is18mm);
      ropeColorOptionsSelect18mm.querySelector('select').disabled = !is18mm;
    }
  }

  const handleBracketColors = () => {
    const bracketColorSelect = document.querySelector('.bracket-color select');
    if (!bracketColorSelect) return;

    const opt = document.createElement('option');
    opt.value = 'none';
    opt.id = 'infinite-brackets';
    opt.innerHTML = 'None';

    selects.forEach(select => {
      const isNoBrackets = select.classList.contains('brackets') && select.options[select.selectedIndex]?.value === 'No';
      toggleVisibility(bracketColorSelect.closest(".bracket-color"), !isNoBrackets, opt);
    });
  };

  handleBracketColors();
  checkNetPlayRopeSelects();
  checkZeroStill();
  checkPZSSeries();

}
  



function snizeRewriteResultsHeader() {
  const el = document.querySelector('.snize-main-panel-collection-results-found');
  if (!el) return;
  const m = el.textContent.match(/([\d,]+)\s+results?/i);
  if (!m) return;
  const title = (document.querySelector('.collection-hero__title, h1') || {}).textContent || '';
  const next = `${m[1]} ${title.trim()}`;
  // const next = `${m[1]} Products`;
  if (el.textContent.trim() !== next) el.textContent = next;
  el.classList.add('visible');
}


(function () {
  const params = new URLSearchParams(location.search);
  if (params.get('chat') !== '1') return;
  const msg = params.get('chat_msg');
  const open = () => {
    if (!window.GorgiasChat) return;
    window.GorgiasChat.init().then(() => {
      if (msg) window.GorgiasChat.setCurrentInput(msg);
      window.GorgiasChat.open();
    });
  };
  window.GorgiasChat ? open() : window.addEventListener('gorgias-widget-loaded', open, { once: true });
})();


  
document.addEventListener('variant:changed', function(event, target) {
    // console.log('variant:changed', event, target);
    if (event.detail.variant) {
  
      // const cratingFeeWidget = document.querySelector('.crating-fee-container');
      // const cratingFeeBtn = cratingFeeWidget?.querySelector('.add-btn');
      // if (cratingFeeBtn) {
      //   cratingFeeBtn?.dataset?.variant = event.detail.variant.id;
      // } 
      // cratingFeeBtn?.dataset.variant = event.detail.variant.id;
      // console.log('cratingFeeBtn.dataset.variant', cratingFeeBtn, cratingFeeBtn.dataset.variant);
  
  
      const variantId = event.detail.variant.id;
      const variantPrice = event.detail.variant.price / 100;
      const selector = document.querySelector('[id^="product-select-"]');
      const selectedVariant = selector.querySelector('[value="' + variantId + '"]');
      console.log('variant:changed', event.detail.variant, event.detail, 'variantId', variantId, 'selected', selectedVariant);
      const vendor = document.querySelector('.product-meta__vendor').textContent;
      // console.log('selectedVariant', selectedVariant, selector);
      const variantTitle = event.detail.variant.title.toLowerCase();
      const productLeadTime = selector.getAttribute('data-product-lead_time').trim();
      let variantLeadTime = selectedVariant.getAttribute('data-lead_time');
      let variantMaxLeadTime = parseInt(selectedVariant.getAttribute('data-max_lead_time'));
      // let variantMinLeadTime = parseInt(selectedVariant.getAttribute('data-min_lead_time'));
      let leadTime = productLeadTime;
  
      // JF - REMOVE AFTER 3/1/2027
      const leadTimeNumbers = variantLeadTime.match(/\d+\s*to\s*\d+/);
      if (event.detail.vendor === 'Playground Equipment' && leadTimeNumbers && variantMaxLeadTime > 6) {
        // console.log('leadTimeNumbers', leadTimeNumbers, variantMaxLeadTime);
        // variantLeadTime = `${leadTimeNumbers[0]} Weeks from 3/1/27`;
        variantLeadTime = `${leadTimeNumbers[0]} Weeks`;
      }
  
      // JF - REMOVE AFTER 5/6/2026
      // if (event.detail.vendor === 'NetPlay USA' ) {
      //   variantLeadTime = '10 to 12 weeks';
      // }
  
      // console.log('event.detail.variant', event.detail.variant);
  
      
      const leadTimeEl = document.getElementById('product-lead-time');
      const leadTimeInput = document.getElementById('lead_time');
  
      const crating_fee = document.getElementById('crating_fee');
      if (crating_fee) { crating_fee.textContent = selectedVariant.getAttribute('data-crating-fee'); }
  
      const fr_fabric_fee = document.getElementById('fr_fabric_fee_variant_id');
      if (fr_fabric_fee) { fr_fabric_fee.textContent = selectedVariant.getAttribute('data-fr-fabric'); }
  
      // Change the weight when variant is changed
      const weightEl = document.getElementById('prod-weight');
      if (weightEl) {
        weightEl.textContent = selectedVariant.getAttribute('data-weight') || '';
      }
  
      const shadeSizeEl = document.querySelector('#shade_size');
      if (shadeSizeEl) {
        shadeSizeEl.textContent = event.detail.variant.title;
      }
  
  
      if (!variantLeadTime || variantLeadTime === "" ) {
        leadTimeEl.innerHTML = productLeadTime;
        leadTime = productLeadTime;
      } else {
        leadTimeEl.innerHTML = variantLeadTime;
        leadTime = variantLeadTime;
        leadTimeInput.value = variantLeadTime;
      }
  
      
      if (leadTime && arrival) {
        let [variantMinLeadTime, variantMaxLeadTime] = leadTime.match(/\d+/g).map(Number);
  
        if (variantMinLeadTime && variantMaxLeadTime) {
          const now = new Date();
          const minDate = new Date(now.setDate(now.getDate() + variantMinLeadTime * 7));
          const maxDate = new Date(now.setDate(now.getDate() + (variantMaxLeadTime - variantMinLeadTime) * 7));
          
          arrival.querySelector('#arrival_min').textContent = new Intl.DateTimeFormat('en-us', dateOptions).format(minDate);
          arrival.querySelector('#arrival_max').textContent = new Intl.DateTimeFormat('en-us', dateOptions).format(maxDate);
        }
      }
      
  
      
      
  
      const isShadeStructures = event.detail.vendor === 'Shade Structures';
      const isQuickShip = isShadeStructures ? variantMaxLeadTime <= 5 : variantMaxLeadTime <= 4;
      const isMadeToOrder = isShadeStructures ? variantMaxLeadTime >= 12 : variantMaxLeadTime >= 14;
  
  
      if (quickShipLabel) {
        quickShipLabel.classList.toggle('hidden', !isQuickShip && !isMadeToOrder);
        quickShipLabel.textContent = isQuickShip ? quickShipText : madeToOrder;
        quickShipTableIcon?.classList.toggle('hidden', !isQuickShip);
        quickShipIconArea?.classList.toggle('hidden', !isQuickShip && !isMadeToOrder);
  
        if (quickShipIconArea) {
          quickShipIconArea.querySelector('#quick-ship-label-text').textContent = isQuickShip ? quickShipText : madeToOrder;
          quickShipIconArea.querySelector('.icon').classList.toggle('hidden', isMadeToOrder);
        }
      }
  
  
  
  
      const infiniteContainer = document.getElementById('infiniteoptions-container');
  
      updateAddonPrices(infiniteContainer, variantPrice);
      checkSelectsForCustomOptions();
  
      // Custom color options: see syncColorOptions and friends near the top of
      // this file. Shared with Shoppad's ready callback so both triggers apply
      // the exact same per-vendor rules.
      syncColorOptions(event.detail.variant, null, infiniteContainer);
  
    }
  
});
  
  
  
  
  
window.addEventListener('quote:item:added', (event) => {
    // console.log('quotes-added', event);
    let quoteItem = document.querySelector('.header__quote-count-new');
    quoteItem.classList.add('newItemAdded');
});
  
  
document.addEventListener('quickview:open', (event) => {
    // console.log('quickview:open', event);
});
  
  
document.addEventListener('contextmenu', function (e) {
    if (e.target.closest('.product-gallery__image') || e.target.closest('.product-gallery__thumbnail') || e.target.closest('.snize-item-image') ) {
      e.preventDefault();
    }
});
  
  // Optional: also block dragging the image to save it
document.addEventListener('dragstart', function (e) {
    if (e.target.closest('.product-gallery__image')) {
      e.preventDefault();
    }
});



  
  
  
document.addEventListener("DOMContentLoaded", () => {

  

  
  // const nofication_clsoe_btn = document.querySelector('.notification__close');
  // if(nofication_clsoe_btn) {
  //   nofication_clsoe_btn.addEventListener('click', (e) => {
  //     e.preventDefault();
  //     leadTimeNote.classList.add('hidden');
  //   });
  // }

  // HIDE CONTENT FOR IP 76.107.199.185
  // fetch('https://ipinfo.io?callback')
  // .then(res => res.json())
  // .then(json => {
  //   if (json.ip == "76.107.199.185") {
  //     document.body.innerHTML = `<div class="content_blocked" style="padding: 10rem; text-align: center; margin: auto">This content is not available in your country</div>`;
  //   }
  // });
  

    

  const first_tab = document.querySelector('.product-horiz-tabs-wrapper .tab-list li');

  if (first_tab) {
    first_tab.setAttribute('aria-expanded', true);
    const targetTab = document.querySelector('.product-horiz-tabs-wrapper .tabs-panel .tab-panel');
    targetTab.classList.add('expanded')
    targetTab.setAttribute('aria-expanded', true);
  }
  

  if (document.querySelector('.horiz-tabs-wrapper')) {
    new HorizontalTabsManager();
  }

  const pdfDownloadButton = document.querySelector('.download-pdf-link');
  if (pdfDownloadButton) {
    pdfDownloadButton.addEventListener('click', (event) => {
      event.preventDefault();
      openPdfInModal(this.href, this.getAttribute('data-quote-number'));
    });
  }


  // const otherContentLinks = document.querySelectorAll('.shipping-video-text a');
  const pdfLinks = document.querySelectorAll('a[href*=".pdf" i]');
  if (pdfLinks) {
    pdfLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        openPdfInModal(link.href, link.textContent);
      });
    });
  }



  



  
  // QUOTE CENTER
  

  const updateIframe = document.getElementById('airtable-update');
  const approvalIframe = document.getElementById('airtable-approval');
  const rejectionIframe = document.getElementById('airtable-rejection');
  const noQuoteFound = document.getElementById('no-quote-found');

  const viewQuoteiFrame = document.getElementById('quote_pdf_iframe');


  // if (updateIframe || approvalIframe || rejectionIframe || viewQuoteiFrame) {

  //   const params = new URLSearchParams(window.location.search);
  //   const quote_pdf_url_link = params.get('quote_pdf');
  //   const quote_pdf_url_link_encoded = encodeURIComponent(quote_pdf_url_link);
  //   const quote_pdf_link_decoded = decodeURIComponent(quote_pdf_url_link);
  //   const quote_number = params.get('quote_number');
  //   const quote_number_encoded = encodeURIComponent(quote_number);
  //   const page_title = document.querySelector('.page__title');
  //   const quote_total = params.get('quote_total');
    
  //   const view_quote_url = `https://willygoat.com/pages/view-quote?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;
    
  //   const setIframeSrc = (iframe, quote_number_enc, path) => {
  //     iframe.src = `https://airtable.com/embed/appWFiIyEXilk7wtJ/${path}/form?prefill_Quote%20Number=${quote_number_enc}`;
  //   };

    

  //   const setTextContent = (id, container) => {
  //     const element = document.getElementById(id);
  //     if (element) element.textContent = container;
  //   };

  //   const setPageTitle = (quote_number) => {
  //     const titleContent = page_title.textContent;
  //     if (page_title && quote_number) page_title.textContent = `${titleContent} - ${quote_number}`;
  //   };

    

  //   const approveButton = document.getElementById('approve-quote-btn');
  //   if (approveButton) approveButton.href = `https://willygoat.com/pages/quote-approval?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

  //   const declineButton = document.getElementById('decline-quote-btn');
  //   if (declineButton) declineButton.href = `https://willygoat.com/pages/quote-rejection?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

  //   const updateButton = document.getElementById('update-quote-btn');
  //   if (updateButton) updateButton.href = `https://willygoat.com/pages/quote-updates?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

  //   const viewQuoteButton = document.getElementById('view-quote-btn');
  //   if (viewQuoteButton) viewQuoteButton.href = `https://willygoat.com/pages/view-quote?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

  //   const updateLink = document.getElementById('modify-link');
  //   if (updateLink) updateLink.href = `https://willygoat.com/pages/quote-updates?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

  //   const approveLink = document.getElementById('approve-link');
  //   if (approveLink) approveLink.href = `https://willygoat.com/pages/quote-approval?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;



  //   const approveButton2 = document.getElementById('approve-quote-btn2');
  //   if (approveButton2) approveButton2.href = `https://willygoat.com/pages/quote-approval?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

  //   const declineButton2 = document.getElementById('decline-quote-btn2');
  //   if (declineButton2) declineButton2.href = `https://willygoat.com/pages/quote-rejection?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

  //   const updateButton2 = document.getElementById('update-quote-btn2');
  //   if (updateButton2) updateButton2.href = `https://willygoat.com/pages/quote-updates?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;


  //   const hideIframe = (iframe) => {
  //     iframe.src = '';
  //     iframe.style.display = 'none';
  //     document.querySelector('#quote-page-content .page__content-inner').textContent = '';
  //     pageTitle.textContent = 'No Quote Found';
      
  //     noQuoteFound.textContent = 'We couldn\'t find a quote with that quote number. Please send us a message our contact our customer service representatives if you need further help.';
  //     noQuoteFound.style.minHeight = '340px';
  //     document.querySelector('.blog-sidebar__item:last-of-type').style.display = 'none';
  //     const goatImg = new Image();
  //     goatImg.src = 'https://cdn.shopify.com/s/files/1/0100/6072/6369/files/goat-fail-new.gif?v=1597690418';
  //     goatImg.style.width = '320px';
  //     goatImg.style.height = 'auto';
  //     noQuoteFound.appendChild(goatImg);
  //   };

  //   if (viewQuoteiFrame) {
  //     let iframe = '<object class="contain" data="' + quote_pdf_link_decoded + '#toolbar=1&navpanes=0&statusbar=0" width="100%" height="' + window.innerHeight + '" style="height: 92vh;"><p>Your web browser doesn\'t have a PDF plugin. Instead you can <a href="' + quote_pdf_link_decoded + '">click here to download.</a></p></object>';
  //     viewQuoteiFrame.innerHTML = iframe;
  //     const pdfDownloadButton = document.getElementById('pdf-download-button');
  //     if (pdfDownloadButton && quote_pdf_url_link) {
  //       console.log('pdfDownloadButton', quote_pdf_url_link);
  //       pdfDownloadButton.href = quote_pdf_url_link;
  //     } else {
  //       pdfDownloadButton?.remove();
  //     }
  //   }

  //   if (quote_number_encoded && (updateIframe || approvalIframe || rejectionIframe)) {
  //     if (updateIframe) setIframeSrc(updateIframe, quote_number_encoded, 'pagfNbfHAPJCrMP3s');
  //     else if (approvalIframe) setIframeSrc(approvalIframe, quote_number_encoded, 'pagcfr8s4KmFB7TuY');
  //     else if (rejectionIframe) setIframeSrc(rejectionIframe, quote_number_encoded, 'pagerLKSyXD3t3cjI');
  //     // noQuoteFound?.style.display = 'none';

  //     const pdfDownloadButton1 = document.getElementById('pdf-download-button2');
  //     if (pdfDownloadButton1 && quote_pdf_link_decoded) {
  //       // pdfDownloadButton1.href = view_quote_url;
  //       pdfDownloadButton1.addEventListener('click', (event) => {
  //         event.preventDefault();
  //         openPdfInModal(quote_pdf_link_decoded, quote_number_encoded);
  //       });
  //     }

  //     const quotePdfLink = document.querySelector('.quote_pdf_link');
  //     if (quotePdfLink && view_quote_url) {
  //       quotePdfLink.href = view_quote_url;
        
  //       // Open PDF in modal when clicked
  //       // if (quote_pdf_link_decoded) {
  //       //   quotePdfLink.addEventListener('click', (event) => {
  //       //     event.preventDefault();
  //       //     openPdfInModal(quote_pdf_link_decoded);
  //       //   });
  //       // }


  //     } else {
  //       quotePdfLink?.remove();
  //     }

      
  //   } else {
  //     [updateIframe, approvalIframe, rejectionIframe].forEach(iframe => iframe && hideIframe(iframe));
  //   }

    

  //   setTextContent('quote-number', quote_number);
  //   setPageTitle(quote_number);

  //   const chatButton = document.getElementById('quote-update-button');
  //   if (chatButton && quote_number) {
  //     chatButton.addEventListener('click', () => {
  //       if (updateIframe) {
  //         window.GorgiasChat.setCurrentInput(`Hello, I need to make changes to my quote ${quote_number}`);
  //       } else if (approvalIframe) {
  //         window.GorgiasChat.setCurrentInput(`Hello, I want to move forward with my quote ${quote_number}`);
  //       } else if (rejectionIframe) {
  //         window.GorgiasChat.setCurrentInput(`Hello, I have a question about my quote ${quote_number}`);
  //       }
  //       window.GorgiasChat.open();
  //     });
  //   }

    

  //   const achChatButton = document.getElementById('quote_chat');
  //   const requestAchButton = document.getElementById('request-ach');
  //   const achTextBtn = document.getElementById('ach-button');
    
  //   if ((achChatButton || achTextBtn) && quote_number) {
  //     (achChatButton || achTextBtn).addEventListener('click', () => {
  //       window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for quote ${quote_number}`);
  //       window.GorgiasChat.open();
  //     });
  //   }

  
  // }





  const quotePortal = document.getElementById('quote_portal');
  const quotePortalNew = document.getElementById('quote_portal_new');

  if (quotePortal || quotePortalNew) {
    const hash = window.location.hash || '';
    const q = hash.indexOf('?');
    const quote_name = q >= 0 ? new URLSearchParams(hash.slice(q)).get('quote_name') : null;
    const quoteOrOrder = quote_name && /^\d/.test(quote_name) ? 'order' : 'quote';

    const chatButton = document.getElementById('quote-update-button');
    const achChatButton = document.getElementById('quote_chat');
    const achTextBtn = document.getElementById('ach-button');

    if ((chatButton || achTextBtn) && quote_name) {
      (chatButton || achTextBtn).addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I have questions about my ${quoteOrOrder} ${quote_name}`);
        window.GorgiasChat.open();
      });
    } else if (chatButton || achTextBtn) {
      (chatButton || achTextBtn).addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I have questions about my Order or Quote`);
        window.GorgiasChat.open();
      });
    }

    
    // console.log('achChatButton', achChatButton);
    if ((achChatButton && quote_name) || (achTextBtn && quote_name)) {
      (achChatButton || achTextBtn).addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for ${quoteOrOrder} ${quote_name}`);
        window.GorgiasChat.open();
      });
    } else if (achChatButton || achTextBtn) {
      (achChatButton || achTextBtn).addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for my Quote`);
        window.GorgiasChat.open();
      });
    }

    const w9InfoButton = document.getElementById('request-w9-info-button');
    if ((w9InfoButton && quote_name)) {
      w9InfoButton.addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I need to request W9 information for quote ${quote_name}`);
        window.GorgiasChat.open();
      });
    } else if (w9InfoButton) {
      w9InfoButton.addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I need to request W9 information for quote or order.`);
        window.GorgiasChat.open();
      });
    }


  }


  // window.Shopify.customerPrivacy.setTrackingConsent({
  //   "marketing": true,
  //   "analytics": true,
  //   "preferences": true,
  //   // "checkoutRootDomain": "checkout.willygoat.shop",
  //   // "storefrontRootDomain": "willygoat.com",
  //   // "storefrontAccessToken": "e21a63df79533cc99106fd28e31ecdd0"
  //   }, () => console.log('consent was submitted')
  // )
  

  var paymentIcons = document.querySelectorAll(".footer svg.payment-list__item");
  paymentIcons.forEach(icon => {
    var titleElement = icon.querySelector("title");
    if (titleElement) {
      icon.removeAttribute('aria-labelledby');
      icon.setAttribute('aria-label', titleElement.textContent);
      var spanElement = document.createElement("title");
      spanElement.innerHTML = titleElement.textContent;
      icon.replaceChild(spanElement, titleElement);
    }
  });






  let originalLeadTimeElement = document.getElementById('product-lead-time');
  if (window.currentVariant && document.querySelector('[id^="product-select-"]')) {
    const variantId = currentVariant.id;
    const selector = document.querySelector('[id^="product-select-"]');
    const selectedVariant = selector.querySelector(`[value="${variantId}"]`);
    const productLeadTime = selector.getAttribute('data-product-lead_time').trim();
    let variantLeadTime = selectedVariant.getAttribute('data-lead_time') || productLeadTime;
    const variantMaxLeadTime = parseInt(selectedVariant.getAttribute('data-max_lead_time'));
    const leadTimeNumbers = variantLeadTime.match(/\d+\s*to\s*\d+/);
    
    
    document.getElementById('product-lead-time').innerHTML = variantLeadTime;
    // console.log('leadTimeNumbers', leadTimeNumbers);

    updateQuickShipIcons(variantMaxLeadTime);
    updateArrivalDates(variantLeadTime);

    // JF - REMOVE AFTER 3/1/2027
    if (window.currentVariant && window.currentProduct.vendor === 'Playground Equipment' && leadTimeNumbers && variantMaxLeadTime >= 6) {
      // console.log('leadTimeNumbers', leadTimeNumbers, variantMaxLeadTime);
      originalLeadTimeElement.innerHTML = `${leadTimeNumbers[0]} Weeks`;
    }


    // JF - REMOVE AFTER 5/6/2026
    // if (window.currentVariant && window.currentProduct.vendor === 'NetPlay USA') {
    //   originalLeadTimeElement.innerHTML = '10 to 12 weeks';
    // }


  } else if (window.currentProduct) {
    
    let originalLeadTime = originalLeadTimeElement.textContent;
    const leadTimeInput = document.getElementById('lead_time');
    const leadTimeNumbers = originalLeadTime.match(/\d+\s*to\s*\d+/);
    // console.log('leadTimeNumbers', leadTimeNumbers);


    if (leadTimeInput) {
      const leadTime = leadTimeInput.value;
      const matches = leadTime.match(/\d+/g);

      let maxLeadTime;
  
      if (matches) {
        if (leadTime.includes('to')) {
          // For ranges like "10 to 12 Weeks", get the second number
          maxLeadTime = parseInt(matches[1]);
        } else {
          // For single numbers like "10 Weeks", get the first number
          maxLeadTime = parseInt(matches[0]);
        }
      }
      maxLeadTime = leadTime.includes('Days') ? 1 : maxLeadTime;
      console.log('maxLeadTime', leadTime, maxLeadTime);


      // let maxLeadTime = matches ? parseInt(matches[1]) : null;
      // maxLeadTime = leadTime.includes('Days') ? 1 : maxLeadTime;
      // console.log('maxLeadTime', leadTime, maxLeadTime);
      if (maxLeadTime) {
        updateQuickShipIcons(maxLeadTime);
      }

      console.log('maxLeadTime', maxLeadTime);

      // JF - REMOVE AFTER 3/1/2026
      if (window.currentProduct && window.currentProduct.vendor === 'Playground Equipment' && leadTimeNumbers && variantMaxLeadTime >= 6) {
        console.log('leadTimeNumbers', leadTimeNumbers, variantMaxLeadTime);
        originalLeadTimeElement.innerHTML = `${leadTimeNumbers[0]} Weeks`;
      }

    }
  }

  

  function updateQuickShipIcons(maxLeadTime) {
    if (!quickShipLabel) return;

    const isQuickShip = maxLeadTime <= 4;
    const isMadeToOrder = maxLeadTime >= 14;
    const isShadeQuickShip = window.currentProduct.vendor === 'Shade Structures' && maxLeadTime <= 5;

    const showQuickShip = isQuickShip || isShadeQuickShip;
    const showMadeToOrder = isMadeToOrder;

    quickShipLabel.classList.toggle('hidden', !showQuickShip && !showMadeToOrder);
    quickShipLabel.textContent = showQuickShip ? quickShipText : madeToOrder;

    quickShipTableIcon?.classList.toggle('hidden', !showQuickShip);
    quickShipIconArea?.classList.toggle('hidden', !showQuickShip && !showMadeToOrder);

    const quickShipLabelText = quickShipIconArea?.querySelector('#quick-ship-label-text');
    const quickShipIcon = quickShipIconArea?.querySelector('.icon');

    if (quickShipLabelText) {
      quickShipLabelText.textContent = showQuickShip ? quickShipText : madeToOrder;
    }
    if (quickShipIcon) {
      quickShipIcon.classList.toggle('hidden', showMadeToOrder);
    }
  }

  function updateArrivalDates(leadTime) {
    const arrival = document.getElementById('arrival');
    if (leadTime && arrival) {
      const [variantMinLeadTime, variantMaxLeadTime] = leadTime.match(/\d+/g).map(Number);
      if (variantMinLeadTime && variantMaxLeadTime) {
        const now = new Date();
        const minDate = new Date(now.setDate(now.getDate() + variantMinLeadTime * 7));
        const maxDate = new Date(now.setDate(now.getDate() + (variantMaxLeadTime - variantMinLeadTime) * 7));
        arrival.querySelector('#arrival_min').textContent = new Intl.DateTimeFormat('en-us', dateOptions).format(minDate);
        arrival.querySelector('#arrival_max').textContent = new Intl.DateTimeFormat('en-us', dateOptions).format(maxDate);
      }
    }
  }


  // const quotePortalSideBar = document.querySelector('#quote-update-recap');
  // if (quotePortalSideBar && window.matchMedia('screen and (min-width: 1024px)').matches) {
  //   const sidebarHeight = quotePortalSideBar.getBoundingClientRect().height;
  //   const contentHeight = document.querySelector('#quote-page-content');
  //   contentHeight.style.minHeight = sidebarHeight + 'px';
  // }
  
});
  
  
  
  
  
  
window.addEventListener('load', () => {


  captureAndStoreGclid();


  const params = new URLSearchParams(window.location.search);
  if (params.get('invoice_number')) {
    setTimeout(() => {
      const invoiceNumber = params.get('invoice_number');
      if (invoiceNumber ) {
        // window.GorgiasChat.init();
        window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for order ${invoiceNumber}`);
        window.GorgiasChat.open();
      }
    }, 1000);
  }

  var initGorgiasChatPromise = (window.GorgiasChat)
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener('gorgias-widget-loaded', function () { resolve(); });
      });

  initGorgiasChatPromise.then(function () {
    // Check if the current URL matches the target page path
    console.log('window.location.pathname', window.location.pathname);
    if (window.location.pathname.includes('/pages/customer-portal')) {
      // Available positions: 'left', 'right', 'bottom-left', or 'bottom-right'
      console.log('setting position to bottom-left');
      GorgiasChat.setPosition('bottom-left');
    }
  });




  

  // Custom Click For Images
  if (window.location.pathname.includes('/collections/')) {

    

    
    snizeRewriteResultsHeader();

    // Searchanise holds the full data for the currently-rendered page here,
    // refreshed on every pagination / filter re-render. No extra fetch needed.
    const snizeItems = () => {
      try {
        return window.Searchanise.GetWidgets().searchResults.getPrevData()?.result?.items || [];
      } catch (e) {
        return [];
      }
    };

    const snizeFindItem = (productId) => {
      const id = String(productId);
      return snizeItems().find(i => String(i.original_product_id) === id || String(i.product_id) === id) || null;
    };

    // swatch.dataset.value ("Primary" / "Neutral" / "Custom") === variant.options[variant.option_color]
    const snizeVariantForColor = (item, value) => {
      const want = String(value).toLowerCase();
      return (item.shopify_variants || []).find(v => {
        const opts = v.options || {};
        const color = (v.option_color && opts[v.option_color] != null)
          ? opts[v.option_color]
          : Object.values(opts).find(o => String(o).toLowerCase() === want);
        return color != null && String(color).toLowerCase() === want && v.image_link;
      }) || null;
    };

    // "PKP027N_Keystone_Crossing_1_large.jpg" -> "PKP027N_Keystone_Crossing_1"
    // Size-agnostic, so a rendered _large src still matches the variant's image_link.
    const snizeImageName = (url) => String(url)
      .split('/').pop().split('?')[0]
      .replace(/\.[a-z]+$/i, '')
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*)$/i, '');

    // ...and once more without the trailing photo number -> "PKP027N_Keystone_Crossing"
    const snizeImageGroup = (url) => snizeImageName(url).replace(/[-_]\d{1,3}$/, '');

    // Shopify assigns only one image per variant, so the hover image has to be inferred:
    // same filename group first, then the next image that isn't another variant's featured image.
    const snizeFlipImage = (item, mainUrl) => {
      const images = item.shopify_images || [];
      const group = snizeImageGroup(mainUrl);
      const sameGroup = images.find(u => u !== mainUrl && snizeImageGroup(u) === group);
      if (sameGroup) return sameGroup;
      const featured = new Set((item.shopify_variants || []).map(v => v.image_link).filter(Boolean));
      const idx = images.indexOf(mainUrl);
      const next = idx > -1 ? images[idx + 1] : null;
      return (next && !featured.has(next)) ? next : null;
    };

    const snizeSetSrc = (img, url) => {
      if (!img || !url || img.getAttribute('src') === url) return;
      const pre = new Image();
      pre.onload = () => { img.src = url; }; // preload so the card never flashes empty
      pre.src = url;
    };

    const snizeColorOf = (variant) => {
      const opts = variant.options || {};
      return variant.option_color ? opts[variant.option_color] : null;
    };

    // every option EXCEPT colour, as a comparable string ("Mount", etc.)
    const snizeOtherOptions = (variant) => {
      const opts = { ...(variant.options || {}) };
      delete opts[variant.option_color];
      return JSON.stringify(opts);
    };

    // The variant for `color` that keeps the other options of the currently-selected one,
    // so switching colour doesn't silently switch Mount as well.
    const snizeVariantLike = (item, color, referenceId) => {
      const variants = item.shopify_variants || [];
      const pool = variants.filter(v => snizeColorOf(v) === color);
      const reference = variants.find(v => String(v.variant_id) === String(referenceId));
      return (reference && pool.find(v => snizeOtherOptions(v) === snizeOtherOptions(reference))) || pool[0] || null;
    };

    // Searchanise highlights the swatch for its DEFAULT variant, but the grid renders the
    // product's featured image - which we alternate Primary/Natural/Custom for variety, so the
    // two disagree on ~7 of 19 swatch cards. Work backwards from the image that's actually on
    // screen and bring the active swatch, the `?variant=` link and data-product-variant to it.
    const snizeSyncCard = (productItem) => {
      if (productItem.dataset.snizeColorPicked) return; // shopper chose a colour - don't second-guess it
      const swatches = [...productItem.querySelectorAll('.snize-color-swatch')];
      if (!swatches.length) return;
      const item = snizeFindItem(productItem.dataset.originalProductId);
      const mainImage = productItem.querySelector('img.snize-item-image:not(.snize-flip-image)');
      if (!item || !mainImage) return;

      const shown = snizeImageName(mainImage.getAttribute('src'));
      const shownVariant = (item.shopify_variants || [])
        .find(v => v.image_link && snizeImageName(v.image_link) === shown);
      const color = shownVariant && snizeColorOf(shownVariant);
      if (!color) return; // featured image isn't assigned to any variant -> keep Searchanise's default

      const target = swatches.find(s => s.dataset.value === color);
      if (!target || target.classList.contains('snize-color-swatch-active')) return;
      swatches.forEach(s => {
        const on = s === target;
        s.classList.toggle('snize-color-swatch-active', on);
        s.setAttribute('aria-checked', String(on)); // they're role="radio"
      });

      const linkVariant = snizeVariantLike(item, color, productItem.dataset.productVariant);
      if (!linkVariant) return;
      productItem.dataset.productVariant = linkVariant.variant_id;
      const viewLink = productItem.querySelector('.snize-view-link');
      if (viewLink?.href) {
        const url = new URL(viewLink.href);
        url.searchParams.set('variant', linkVariant.variant_id);
        viewLink.href = url.toString();
      }
    };

    const snizeSyncGrid = () => document.querySelectorAll('.snize-product').forEach(snizeSyncCard);

    // snizeSetSrc only starts its fetch on click, so the first click of a colour waits for the
    // download (measured 40-190ms warm connection, 350-500ms cold; ~3ms once cached). Warming
    // the cache on swatch hover makes the swap instant. Hover-scoped on purpose: eagerly
    // preloading every swatch colour on this page would be ~35 images / ~1.2MB.
    const snizePreloaded = new Map();
    const snizePreload = (url) => {
      if (!url || snizePreloaded.has(url)) return;
      const pre = new Image();
      snizePreloaded.set(url, pre); // hold the reference so the request isn't GC'd mid-flight
      pre.src = url;
    };

    const snizePreloadColor = (productItem, color) => {
      const item = snizeFindItem(productItem.dataset.originalProductId);
      const variant = item && snizeVariantForColor(item, color);
      if (!variant) return;
      snizePreload(variant.image_link);
      snizePreload(snizeFlipImage(item, variant.image_link)); // they may hover the card next
    };

    const snizeDesktop = window.matchMedia('(min-width: 1024px)');

    document.addEventListener('click', (e) => {
      const swatch = e.target.closest('.snize-color-swatch-box .snize-color-swatch');
      if (!swatch) return;
      e.preventDefault();
      const productItem = swatch.closest('.snize-product');
      if (!productItem) return;
      
      productItem.querySelector('.snize-view-link')?.classList.add('hover');
      // productItem.querySelector('.snize-view-link')?.classList.toggle('hover', !!e.target.closest('.snize-color-swatch-box'));

      // From here on this card is shopper-driven. Without this the re-render observer runs
      // snizeSyncCard ~8ms after the click, reads the image src BEFORE the preload below has
      // swapped it, and drags the active swatch back to the old colour - the "click it twice"
      // bug. Set before the desktop gate so mobile (no image swap) is covered too.
      productItem.dataset.snizeColorPicked = swatch.dataset.value;

      // Swap the card image to the clicked swatch's variant image (desktop only)
      if (snizeDesktop.matches) {
        const item = snizeFindItem(productItem.dataset.originalProductId);
        const variant = item && snizeVariantForColor(item, swatch.dataset.value);
        // console.log('variant', variant, swatch.dataset.value, swatch.dataset);
        if (variant) { // no variant image assigned in Shopify -> leave the card alone
          const mainImage = productItem.querySelector('img.snize-item-image:not(.snize-flip-image)');
          const flipImage = productItem.querySelector('img.snize-item-image.snize-flip-image');
          snizeSetSrc(mainImage, variant.image_link);
          if (mainImage && variant.image_alt) mainImage.alt = variant.image_alt;
          snizeSetSrc(flipImage, snizeFlipImage(item, variant.image_link) || variant.image_link);
        }
      }

      if (!productItem.classList.contains('snize-product-tag-__labelquick-ship')) return;
      productItem.querySelector('.snize-product-label.top-right')?.classList.toggle('hidden', swatch.dataset.value === 'Custom');
    });

    // theme.css pins the selected colour via `.snize-view-link.hover` (flip image forced to
    // opacity 0). Keep that pin only while the cursor is on the swatch strip, so moving onto
    // the card still flips to the second photo of the colour that's now selected.
    document.addEventListener('mouseover', (e) => {
      const productItem = e.target.closest?.('.snize-product');
      if (!productItem) return;
      productItem.querySelector('.snize-view-link')
        ?.classList.toggle('hover', !!e.target.closest('.snize-color-swatch-box'));

      const swatch = e.target.closest('.snize-color-swatch-box .snize-color-swatch');
      if (swatch && snizeDesktop.matches) snizePreloadColor(productItem, swatch.dataset.value);
    });

    // Searchanise exposes no render callback, so watch the results container. Only childList is
    // observed, so the class/href/dataset writes in snizeSyncCard can't retrigger this.
    const snizeResults = document.getElementById('snize_results');
    if (snizeResults) {
      let snizeSyncQueued = false;
      new MutationObserver(() => {
        if (snizeSyncQueued) return;
        snizeSyncQueued = true;
        requestAnimationFrame(() => {
          snizeSyncQueued = false;
          snizeSyncGrid();
          snizeRewriteResultsHeader();
        });
      }).observe(snizeResults, { childList: true, subtree: true });
    }
    snizeSyncGrid(); // in case the grid rendered before this ran
  }




  let convertButtons = document.querySelectorAll('.convert_to_cart_button');
  if (convertButtons) {
    convertButtons.forEach( convertButton => {
      convertButton.addEventListener('click', convertQuoteToCart);
    });
  }

  // document.querySelectorAll('.blog-testimonials-blocks_slider .flickity-slider .blog-testimonials__item').style.height = '100%';
  document.querySelectorAll('.blog-testimonials-blocks_slider .flickity-slider .blog-testimonials__item').forEach(item => {
    item.style.height = '100%';
  });

  if (window.currentProduct && quickShipLabel) {
    if (currentProduct.tags.includes('__label:Quick Ship') && currentProduct.title == "GaGa2Go Portable GaGa Ball Pit") {
      quickShipLabel.classList.remove('hidden');
    }
  }


  


  // Hide filters if there is only one option
  const productTypeFilter = document.getElementById('snize_filters_block_product_type');
  const productTypeFilterItems = productTypeFilter?.querySelectorAll('.snize-product-filters-list li');

  if (productTypeFilter && productTypeFilterItems.length == 1) {
    productTypeFilter.closest('.snize-product-filters-block').style.display = 'none';
  }

  const banner_img = document.querySelector('.snize-banner a img');
  banner_img && (banner_img.alt = 'WillyGoat Installation Services');

  if (banner_img && window.innerWidth < 768) {
    banner_img.closest('.snize-banner').style.display = 'none';
  }

  // const filters = document.querySelectorAll('.snize-product-filters-list');
  // filters.forEach(filter => {
  //   let filterItems = filter.querySelectorAll('li');
  //   if (filterItems.length == 1) {
  //     filter.closest('.snize-product-filters-block').style.display = 'none';
  //   }
  // });

  
  const shopifyAccessibilityIssue = document.querySelector('shop-cart-sync iframe');
  if (shopifyAccessibilityIssue) {
    shopifyAccessibilityIssue.title = 'Shopify Cart Sync';
  }
  // console.log('shopifyAccessibilityIssue', shopifyAccessibilityIssue);
  
});
  
  
  
  // JOEL - JF
var HorizontalTabsManager = class {
    constructor() {
      this.tabs = document.querySelector('.horiz-tabs-wrapper');
      
      this.tabLinks = this.tabs.querySelectorAll('.horiz-tab');
      this.tabPanes = this.tabs.querySelectorAll('.tab-panel');
      // this.domDelegate = new main_default(document.body);
      console.log('this.tabs', this.tabLinks);
      this._attachListeners();
    }
    _attachListeners() {
      // this.domDelegate.on("click", '[data-action="toggle-tabs"]:not([disabled])', this._handleTabClick.bind(this));
      // document.addEventListener("tabs:toggle", this._handleTabClick.bind(this));
  
      this.tabLinks.forEach(tab => {
        tab.addEventListener('click', (event) => this._handleTabClick(tab) );
      });
    }
  
    _handleTabClick(target) {
      this.tabLinks.forEach((tab) => {
        tab.classList.remove('expanded');
        tab.setAttribute('aria-expanded', false);
      });
      this.tabPanes.forEach((pane) => {
        pane.classList.remove('expanded');
        pane.setAttribute('aria-expanded', false);
      });
  
      const tabId = target.getAttribute('aria-controls');
      const targetTab = document.getElementById(tabId);
      target.setAttribute('aria-expanded', true);
      targetTab.classList.add('expanded')
      targetTab.setAttribute('aria-expanded', true);
    }
    
}
  
  
  
  
document.addEventListener('theme:loading:end', function(event) {
    // sortSelect(prodTypeSelect);
  
    maxHeightGallery();
  
  
  
  
    // Open all links in the tabs into a modal rather than opening a new window or tab
    let productLinks = document.querySelectorAll('.product-block-list__item--content a[target="_blank"]:not(.download-pdf), .product-block-list__item--info .product-block-list__item:not(.product-block-list__item--share) a[target="_blank"], .mini-cart__property-list a.manual_url[target="_blank"]');
    // console.log('[-- productLinks --]', productLinks);
    // if (window.matchMedia('screen and (min-width: 640px)').matches) {
      openDocsInModal(productLinks);
    // }
    
  
  
    
    // Sort Product Types in Native Search (Not Shown when using Boost Search)
    let prodTypeSelect = document.getElementById('search-product-type');
    if (prodTypeSelect) {
      const optionNodes = Array.from(prodTypeSelect.children);
      const comparator = new Intl.Collator(optionNodes.value).compare;
      prodTypeSelect.innerHTML = "";
      optionNodes.sort((a, b) => comparator(a.textContent, b.textContent));
      optionNodes.forEach((option) => prodTypeSelect.appendChild(option));
    }
  
  
    // let shippingProvinceSelect = document.getElementById('shipping-estimator-country');
    // if (shippingProvinceSelect) {
    //   let provincesJsonData = shippingProvinceSelect.getAttribute('data-provinces');
    //   if (provincesJsonData) {
    //     let provincesJSON = JSON.parse(provincesJsonData);
    //     const comparator = new Intl.Collator(provincesJSON).compare;
    //     shippingProvinceSelect.innerHTML = "";
    //     provincesJSON.filter((j, b) => !j.includes('Virgin Islands') && !j.includes('Puerto Rico') && !j.includes('Palau') && !j.includes('Mariana Islands') && !j.includes('Hawaii') && !j.includes('Marshall Islands') && !j.includes('Alaska') && !j.includes('Guam') && !j.includes('Armed Forces') && !j.includes('Marshall') && !j.includes('Micronesia') && !j.includes('Armed Forces Americas') && !j.includes('American Samoa') && !j.includes('Armed Forces Europe') && !j.includes('Armed Forces Pacific') && !j.includes('Northern Mariana Islands') )
    //     let json2 = provincesJSON.filter(j => (
    //       !j.includes('Virgin Islands') && !j.includes('Puerto Rico') && !j.includes('Palau') && !j.includes('Mariana Islands') && !j.includes('Hawaii') && !j.includes('Marshall Islands') && !j.includes('Alaska') && !j.includes('Guam') && !j.includes('Armed Forces') && !j.includes('Marshall') && !j.includes('Micronesia') && !j.includes('Armed Forces Americas') && !j.includes('American Samoa') && !j.includes('Armed Forces Europe') && !j.includes('Armed Forces Pacific') && !j.includes('Northern Mariana Islands') 
    //     ))
    //     console.log(json2);
    //     // shippingProvinceSelect.setAttribute('data-provinces', json2);
    //   }
    // }
    
  
  
  
  
    // Track Manual Clicks
    const manualTab = document.getElementById('unique-tab-resources');
    const productJsonElement = document.querySelector('[data-product-json]');
    if (productJsonElement && manualTab) {
      const manualLinks = manualTab.querySelectorAll('.manual_url');
      let jsonData = JSON.parse(productJsonElement.innerHTML);
      let productData = jsonData['product'];
      // console.log('productData', productData);
  
      const trackManualClick = (productData) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'product_manual_open',
          product: productData.title,
          url: 'https://willygoat.com/products/' + productData.handle,
          brand: productData.vendor
        });
        manualLink.removeEventListener('click', trackManualClick);
      }
    
      manualLinks.forEach(manualLink => {
        manualLink.addEventListener('click', trackManualClick);
      });
    }
    
});
  
  
  
  
function captureAndStoreGclid() {
    const urlParams = new URLSearchParams(window.location.search);
    // const gclidParam = urlParams.get('gclid') || getGclidFromElevar();
    const gclidParam = urlParams.get('gclid');
    // let storedGclid = localStorage.getItem('gclid_value');
  
    // utm_campaign
    const utm_campaign = urlParams.get('utm_campaign');
    // const magazineVisitor = urlParams.get('Church_10_24');
  
    if (gclidParam) {
      const gclidValue = JSON.stringify(gclidParam);
      localStorage.setItem('gclid_value', gclidParam);
      // localStorage.setItem('gclid', gclidParam);
      localStorage.setItem('google_ads_click_id', gclidParam);
    }
  
    if (utm_campaign == 'Church_10_24') {
      localStorage.setItem('wg_church_10_24_visitor', 'true');
    }
}
  
function getGclidFromElevar() {
    const elevarData = localStorage.getItem('___ELEVAR_GTM_SUITE--params');
    if (elevarData) {
      const parsedElevarData = JSON.parse(elevarData);
      return parsedElevarData.google_ads_click_id?.replace('gclid:', '');
    }
    return null;
}
  
  
  
/*
function getParam(p) {
    let match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }
    
  function getExpiryRecord(value) {
    const expiryPeriod = 90 * 24 * 60 * 60 * 1000;
    let expiryDate = new Date().getTime() + expiryPeriod;
    return {
      value: value,
      expiryDate: expiryDate
    };
  }
  
  function addGclid() {
    let gclidParam = getParam('gclid');
    // let gclidRecord = null;
  
    if (gclidParam) {
      // gclidRecord = getExpiryRecord(gclidParam);
      localStorage.setItem('gclid', JSON.stringify(gclidParam));
      localStorage.setItem('gclid_value', JSON.stringify(gclidParam));
    }
  
    let elevarData = localStorage.getItem('___ELEVAR_GTM_SUITE--params');
    if (elevarData) {
      let parsedElevarData = JSON.parse(elevarData);
      let gclid = parsedElevarData.gclid ? parsedElevarData.gclid : parsedElevarData.google_ads_click_id ? parsedElevarData.google_ads_click_id?.replace('gclid:', '') : JSON.stringify(gclidParam);
      
      localStorage.setItem('google_ads_click_id', JSON.stringify(gclid));
    }
}
*/
  
  
  
  
  
const equalHeightTitles = (elems) => {
    const heights = elems.map(el => el.querySelector('.product__title-heading').offsetHeight);
    const maxHeight = Math.max(...heights);
    elems.forEach(el => {
      el.querySelector('.product__title-heading').style.height = `${maxHeight}px`;
    });
};
  
const maxHeightGallery = function() {
    if (window.matchMedia('screen and (min-width: 1024px)').matches && document.querySelectorAll('.product-gallery__carousel').length ) {
      let productCarousel = document.querySelectorAll('.product-gallery__carousel')[0];
      let galleryThumbs = document.querySelectorAll('.product-gallery__thumbnail-list')[0];
      if (galleryThumbs) {
        let origHeight = parseInt(getStyle(galleryThumbs, "max-height"));
        if ( productCarousel.clientHeight >= origHeight ) {
          galleryThumbs.style['maxHeight'] = "".concat((productCarousel.clientHeight - 8), "px");
        }
      }
    }
}
  
  
  
var sortSelect = function(selElem) {
    var tmpAry = new Array();
    for (var i = 0; i < selElem.options.length; i++) {
      tmpAry[i] = new Array();
      tmpAry[i][0] = selElem.options[i].text;
      tmpAry[i][1] = selElem.options[i].value;
    }
    tmpAry.sort();
    while (selElem.options.length > 0) {
      selElem.options[0] = null;
    }
    for (var i=0;i<tmpAry.length;i++) {
      var op = new Option(tmpAry[i][0], tmpAry[i][1]);
      selElem.options[i] = op;
    }
    return;
}
  
  
  
  
  
  
  
  
  
  
  
  
// document.addEventListener('theme:loading:end', function(event) {
window.Shoppad = window.Shoppad || {},
window.Shoppad.apps = window.Shoppad.apps || {},
window.Shoppad.apps.infiniteoptions = window.Shoppad.apps.infiniteoptions || {},
window.Shoppad.apps.infiniteoptions.ready = function() {
  
    const infiniteContainer = document.getElementById('infiniteoptions-container');
    const vendor = document.querySelector('.product-meta__vendor').textContent;
  
    const productForm = document.querySelector('.product-form');
  
    // Custom color options: same rules as the 'variant:changed' handler (see
    // syncColorOptions near the top of the file) - kept in one place so
    // page-load and variant-change can never disagree about which color
    // pickers should be visible.
    syncColorOptions(null, productForm, infiniteContainer);
  
    updateAddonPrices(infiniteContainer);
    checkSelectsForCustomOptions();
    
    // checkNetPlayRopeSelects();
  
  
  
    // let mounting_option = infiniteContainer.querySelector('#mounting_option-0-0');
    const mounting_option = infiniteContainer.querySelector('[for^="mounting_option-"], [id^="mounting_option-"], [for^="mounting_options-"], [id="mounting_option-1-0"]');
    const install_tab = document.querySelector('[class^="tab-installation-tab"], .tab-installation-tab, .tab-installation-tab-pe, .tab-installation-shades');
    
    if ( mounting_option && install_tab ) {
      mounting_option.setAttribute('data-tooltip', 'Please see installation tab below for more information.');
    }
  
    
    const colorSwatches = infiniteContainer.querySelectorAll('.ultraplay-colors, .rope-color, .uplay-colors');
    colorSwatches.forEach(swatch => {
      const label = swatch.querySelector('.spb-label-tooltip label');
      const labelText = label.textContent + ':&nbsp;';
      const inputs = swatch.querySelectorAll('input[type=radio], input[type=checkbox]');
      const skuArea = document.querySelector('.product-meta__sku-number');
      const skuValue = skuArea.textContent;
  
      const updateLabel = (input) => {
        label.innerHTML = `${labelText}<span class='product-form__selected-value'>${input.value}</span>`;
        if (skuArea ) {
          skuArea.textContent = `${skuValue} - ${input.value}`.trim();
        }
      };
  
      inputs.forEach(input => {
        if (input.checked) updateLabel(input);
        input.addEventListener('change', () => updateLabel(input));
      });
    });
  
    // Show the select boxes value in the accoompanying label when selected
    const infinSelects = infiniteContainer.querySelectorAll('.spb-select');
    // console.log('infinSelects', infinSelects);
    infinSelects.forEach(select => {
      let label = select.closest('.infin-option').querySelector('.spb-label-tooltip label');
      const labelText = label.textContent + ':&nbsp;';
  
      select.addEventListener('change', (event) => {
        // console.log('event', event.target);
        label.innerHTML = labelText + "<span class='product-form__selected-value'>" + event.target.value + "</span>";
      });
    });
  
    
  
    // Check if the california resident radio button is checked and update the add to cart button
    if (document.querySelector('[name="properties[california_resident]"]')) {
      const californiaRadios = document.getElementsByName('properties[california_resident]');
      const cartBtn = document.querySelector('.product-form__add-button');
      const paymentContainer = cartBtn.closest('.product-form__payment-container');
      const shopifyPaymentBtn = document.querySelector('.shopify-payment-button');
      const galleryImageLinks = document.querySelectorAll('.product-gallery__thumbnail');
  
      californiaRadios.forEach(radio => {
        radio.addEventListener('change', (event) => {
          const isCaliforniaResident = event.target.value === 'Yes';
          cartBtn.classList.toggle('visually-hidden', isCaliforniaResident);
          paymentContainer.classList.toggle('no-quote', isCaliforniaResident);
          shopifyPaymentBtn.classList.toggle('visually-hidden', isCaliforniaResident);
          if (vendor == 'Shade Structures') {
            console.log('galleryImageLinks', galleryImageLinks, isCaliforniaResident, galleryImageLinks.length);
            galleryImageLinks[isCaliforniaResident ? galleryImageLinks.length - 1 : 3].click();
          }
        });
      });
    }
  
  
  };
  
  
  
  
  
  
  
  // Infinite Options - Adds the price to the extra product options 
const updateAddonPrices = (infiniteContainer, variantPrice = window.currentVariant.price / 100) => {
    const productForm = document.querySelector('.product-form');
    const variantPriceEl = productForm.querySelector('.price-list .price');
  
    if (variantPrice) {
      const infiniteInputs = infiniteContainer.querySelectorAll('input:not([type=hidden]), select');
      const updatePrice = () => {
        const updatedPrice = calculateTotalPrice(infiniteContainer, variantPrice);
        variantPriceEl.innerHTML = updatedPrice.formatMoney('$', 2, ',', '.');
      };
  
      infiniteInputs.forEach(inputEl => {
        updatePrice(); // Initial price update
        inputEl.addEventListener('change', updatePrice);
      });
    }
};
  
const calculateTotalPrice = (container, basePrice) => {
    const inputs = container.querySelectorAll("input:not([type=hidden]), select");
  
    const additionalPrice = Array.from(inputs).reduce((total, inputEl) => {
      let priceToAdd = 0;
      const nextSibling = inputEl.nextSibling;
  
      if ((inputEl.type === 'radio' || inputEl.type === 'checkbox') && inputEl.checked && nextSibling && nextSibling.nodeType === Node.ELEMENT_NODE && nextSibling.hasAttribute('data-price')) {
        priceToAdd = parseFloat(inputEl.nextSibling.getAttribute('data-price'));
      } else if (inputEl.type === 'select-one' && inputEl.selectedIndex >= 0) {
        const selectedOption = inputEl.options[inputEl.selectedIndex];
        if (selectedOption.hasAttribute('data-price')) {
          priceToAdd = parseFloat(selectedOption.getAttribute('data-price'));
        }
      }
      return total + priceToAdd;
    }, 0);
  
    return basePrice + additionalPrice;
};
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
const convertQuoteToCart = async (event) => {
    event.preventDefault();
    try {
      const quoteItemsRaw = localStorage.getItem('quoteItems');
      if (!quoteItemsRaw) {
        console.error('No quote items found in localStorage.');
        return;
      }
  
      const quoteItems = JSON.parse(quoteItemsRaw);
      // const items = quoteItems.map(({ variantId, quantity, options }) => ({
      //   id: variantId,
      //   quantity,
      //   properties: options ? options.reduce((acc, { key, value }) => ({ ...acc, [key.replace('_', '')]: value }), {}) : {}
      // }));
      const items = quoteItems
        .filter(({ tags, quoteOnly }) => !tags || !tags.includes('Hide Price') || !quoteOnly)
        .map(({ variantId, quantity, options }) => ({
          id: variantId,
          quantity,
          properties: options ? options.reduce((acc, { key, value }) => ({ ...acc, [key.replace('_', '')]: value }), {}) : {}
      }));
  
      const formData = { items };
      const response = await fetch(`${window.routes.cartAddUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      });
  
      if (!response.ok) throw new Error('Network response was not ok.');
  
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      document.querySelector('.header__cart-toggle')?.click();
    } catch (error) {
      console.error('Error converting quote to cart:', error);
    }
};
  
  
  
  
  
function openPdfInModal(pdfUrl, pdfTitle = null) {
    let modal = document.getElementById('modal-pdf-links');
    if (!modal || !pdfUrl) {
      console.log('Modal or PDF URL missing', { modal: !!modal, pdfUrl: !!pdfUrl });
      return;
    }
  
    let modalTitle = modal.querySelector('.modal__title');
    if (pdfTitle && modalTitle) {
      const titleContent = decodeURIComponent(pdfTitle);
      modalTitle.textContent = titleContent;
    }
    let modalContent = modal.querySelector('.modal__content');
    let closeBtn = modal.querySelector('.modal__close');
    let iframe = '<object class="contain" data="' + pdfUrl + '#navpanes=0&zoom=110" width="100%" height="' + window.innerHeight + '" style="height: 70vh;"><p>Your web browser doesn\'t have a PDF plugin. Instead you can <a href="' + pdfUrl + '">click here to download.</a></p></object>';
    modalContent.innerHTML = iframe;
    console.log('iframe', iframe);
  
    let onOpen = function onOpen(event) {
      if (event.propertyName === 'visibility') {
        modal.removeEventListener('transitionend', onOpen);
        closeBtn.addEventListener('click', closeModal);
        document.body.addEventListener('click', checkClickOutside);
        document.body.addEventListener('keyup', escapePressed);
      }
    };
  
    function closeModal() {
      let onClose = function onClose(event) {
        if (event.propertyName === 'visibility') {
          modal.removeEventListener('transitionend', onClose);
          modal.dispatchEvent(new CustomEvent('modal:closed'));
          closeBtn.removeEventListener('click', closeModal);
          document.body.removeEventListener('keyup', escapePressed);
          document.body.removeEventListener('click', checkClickOutside);
        }
      };
  
      modal.addEventListener('transitionend', onClose);
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('is-locked');
    }
  
    function checkClickOutside(event) {
      if (modal && (!modal.contains(event.target) || modal === event.target)) {
        closeModal();
      }
    }
  
    function escapePressed(event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    }
  
    modal.addEventListener('transitionend', onOpen);
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
}
  
window.openPdfInModal = openPdfInModal;
  
function openDocsInModal(linksArray) {
    linksArray.forEach(decorateLinks);
    function decorateLinks(link, index) {
      let href_value = link.getAttribute("href");
      let modal = document.getElementById('modal-pdf-links');
  
      if (modal && window.matchMedia('screen and (min-width: 640px)').matches && /\.(gif|jpg|jpeg|tiff|png|pdf|pdf\\?55|jpg\\?55|png\\?55|pdf\\?.*|jpg\?.*)$/i.test(href_value)) {
        let modalContent = modal.querySelector('.modal__content');
        let closeBtn = modal.querySelector('.modal__close');
  
        link.onclick = function(event) {
          let iframe = '<object class="contain" data="' + href_value + '#navpanes=0&zoom=FitH" width="100%" height="' + window.innerHeight + '" style="height: 70vh;"><p>Your web browser doesn\'t have a PDF plugin. Instead you can <a href="' + href_value + '">click here to download.</a></p></object>';
          modalContent.innerHTML = iframe;
  
          let onOpen = function onOpen(event) {
            if (event.propertyName === 'visibility') {
              modal.removeEventListener('transitionend', onOpen);
              closeBtn.addEventListener('click', closeModal);
              document.body.addEventListener('click', checkClickOutside);
              document.body.addEventListener('keyup', escapePressed);
            }
          };
  
          modal.addEventListener('transitionend', onOpen);
          modal.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('is-locked');
  
          return false;
        }
  
        function closeModal() {
          let onClose = function onClose(event) {
            if (event.propertyName === 'visibility') {
              modal.removeEventListener('transitionend', onClose);
              modal.dispatchEvent(new CustomEvent('modal:closed'));
              closeBtn.removeEventListener('click', onClose);
              document.body.removeEventListener('keyup', escapePressed);
              document.body.removeEventListener('click', checkClickOutside);
            }
          };
  
          modal.addEventListener('transitionend', onClose);
          modal.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('is-locked');
  
          return false;
        }
  
        function checkClickOutside(event) {
          if (modal && (!modal.contains(event.target) || modal === event.target)) {
            closeModal();
          }
        }
  
        function escapePressed(event) {
          if (event.key === 'Escape') {
            closeModal();
          }
        }
      }
    }
}
  
  
function strip(html){
     var tmp = document.createElement("DIV");
     tmp.innerHTML = html;
     return tmp.textContent||tmp.innerText;
}
  
  
async function htmlToPDFFlyer(){
    // var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF();
    // var doc = new jsPDF('p', 'in', [8.5, 11]);
    // var footer = '<a href="https:willygoat.com">willygoat.com</a> | <a href="mailto:fun@willygoat.com">fun@willygoat.com</a> | 888-920-4628';
    var footer = 'willygoat.com | fun@willygoat.com | 888-920-4628';
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy;
    
    var product_template = "https://cdn.shopify.com/s/files/1/0100/6072/6369/files/Sell_Sheet_Template7.png?v=1757090669";
    var product_image = document.querySelector(".product-gallery__image");
    let main_image = product_image.src;
  
    var product_title = document.querySelector(".product-meta__title");
    var product_vendor = document.querySelector(".product-meta__vendor");
    var product_description = document.querySelector(".description-above > p");
    var product_specification = document.querySelector("#unique-tab-product_specs");
    
    // var product_weight = document.querySelector("#prod-weight");
  
    var features_list_items = document.querySelectorAll('#unique-tab-features .tab-list:not(#play-events-list)');
  
    var spec_details = document.querySelector('#unique-tab-product_specs');
    var spec_list_items;
    if (spec_details) {
      spec_list_items = spec_details.querySelectorAll('.tab-list:not(.secondary-list)');
    }
  
    var play_events = document.querySelector('#play-events-list');
    var play_events_rows = document.querySelectorAll('#play-events-list li');
    var spec_table, spec_table_rows, spec_labels, spec_values;
    if (product_specification) {
      spec_table = product_specification.querySelector('.spec-table');
      spec_table_rows = spec_table.querySelectorAll('tr');
      // spec_labels = spec_table.querySelectorAll('.spec-label').textContent;
      // spec_values = spec_table.querySelectorAll('.spec-value').textContent;
    }
  
    
  
    var materials = document.querySelector('#materials-list');
    var materials_rows = document.querySelectorAll('#materials-list li');
    
    var sale_price = document.querySelector(".product-form__info-item .price--highlight");
    var regular_price = document.querySelector(".product-form__info-item .price--compare");
    var regular_price_solo = document.querySelector('.product-form__info-content .price ');
  
    // console.log('spec_table_rows', spec_table_rows);
    
    var html_code = '<style>'
                      + '*, *:before, *:after { box-sizing: border-box!important; line-height: 0.5; font-family: "Open Sans",-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; }'
                      + 'html, body { color: #677279; font-family: "Open Sans",-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; box-sizing: border-box!important; }'
                      + '.heading, h1, h2, h3, h4, h5, h6 { color: #317853; font-weight: bold; margin: 0 0 2px 0; text-transform:uppercase; }'
                      + 'h3{font-size:16px;margin:0;}'
                      + 'h4{font-size:15px;margin:0;text-transform:uppercase;}'
                      + 'h5{font-size:14px;margin:0;text-transform:uppercase;}'
                      + 'ul,li{list-style:none;margin:2px 0;}'
                      + 'table{color:#677279;border-collapse:collapse;border-spacing:0;margin:0;}'
                      + 'table tr{display:table-row;font-size:10px;}'
                      + 'table tr td{display:table-cell;border:1px solid #d5d7d9; padding: 1px 2px; margin:0!important; }'
                      + 'table tr td > * {margin:0;line-height:0.2;}'
                      + 'p {color:#677279;font-size:10px;line-height:0.2;}'
                      + 'span {color:#677279;font-size:10px;line-height:0.2;}'
                      + 'table span {color:#677279;font-size:10px;line-height:0.2;padding:0;margin:0;}'
                      + '.row-content {font-size:10px;color:#677279;line-height:0.2;padding:0;margin:0;}'
                      + '.list-item {color:#677279;}'
                  + '</style>'
    // Open container div
    // html_code += ';
    html_code += '</br></br></br></br></br></br><div class="date" style="float:right;color:#677279;font-size:14px;">' + today + '</div>';
    html_code += '<div style="font-family: "Open Sans",Helvetica,sans-serif;">';
    
    html_code += ''
      +     '<h4 style="text-align:left;color:#317853; margin-top: 15px;">'+product_title.innerHTML+'</h4>';
    html_code += '</br>';
  
    if (product_image) {
      html_code += '<div><img align="right" style="float:right;min-height:60px;" src=' + main_image + ' width="80" ></div>';
    }
    // doc.setFontSize(12);
    if (product_vendor) {
      html_code += '<div style="line-height:16px;font-size:14px;color:#317853;"><span style="color:#317853;">Brand: </span> <span style="color:#677279;font-weight:bold;">' + product_vendor.textContent + '</span></div>';
    }
    doc.setFontSize(14);
    if (regular_price) {
      var regular_price_val = regular_price.innerHTML.replace('<span class="visually-hidden">Regular Price</span>', '').trim();
      html_code += '<div style="line-height:16px;font-size:14px;"><span style="color:#677279;line-height:16px;">Regular Price: </span> <span style="color:#677279;font-weight:bold;line-height:16px;text-decoration:line-through;">' + regular_price_val + '</span></div>';
    }
  
    if (sale_price) {
      var sale_price_val = sale_price.innerHTML.replace('<span class="visually-hidden">Sale Price</span>', '').trim();
      html_code += '<div style="line-height:16px;font-size:14px;"><span style="color:red;line-height:16px;">Sale Price: </span> <span style="color:#000000;font-weight:bold;line-height:16px;">' + sale_price_val + '</span></div>';
    } else if (regular_price_solo) {
      var regular_price_solo_val = regular_price_solo.innerHTML.replace('<span class="visually-hidden">Sale Price</span>', '').trim();
      html_code += '<div style="line-height:16px;font-size:14px;"><span style="color:red;line-height:16px;">Price: </span> <span style="color:#000000;font-weight:bold;line-height:16px;">' + regular_price_solo_val + '</span></div>';
    }
  
    if (play_events_rows.length) {
      html_code += '</br>';
      html_code += '<h5 class="heading" style="font-size:12px;font-weight:bold;margin:2px 0 2px 0;line-height:0;">Play Events: </h5>';
      html_code += '<div style="margin:2px 0;">';
      play_events_rows.forEach( row => {
        html_code += '<span class="row-content" style="font-size:10px!important; line-height:0px;" >' + row.textContent + ' &nbsp;</span>';
      });
      html_code += '</div>';
    }
  
  
    if (features_list_items) {
      html_code += '</br>';
      features_list_items.forEach( feature_list => {
        // console.log('feature_list', feature_list);
        // doc.setTextColor(49, 120, 83);
        if (feature_list.previousElementSibling) {
          html_code += '<h5 class="heading"  style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;">' + strip(feature_list.previousElementSibling.innerText) + ':</h5>';
        } else if (feature_list.classList.contains('expandable-content')) {
          html_code += '<h5 class="heading"  style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;">' + strip(feature_list.closest('.list-expandable-wrapper').previousElementSibling.textContent) + ':</h5>';
        } else {
          html_code += '<h5 class="heading"  style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;">Features:</h5>';
        }
        feature_list.querySelectorAll('li').forEach( list_item => {
          if (list_item.classList.contains('tab-icon') && !list_item.querySelector('.recycled') ) {
            html_code += '<span class="list-item" style="font-size:10px;display:block;line-height:13px;">' + strip(list_item.querySelector('.shade-cert').textContent.replace('.shade-cert0{fill:none;stroke:var(--heading-color);stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}', '')) + '</span>';
          } else {
            if (list_item.querySelector('.text-content')) {
              html_code += '<span class="list-item" style="font-size:10px;display:block;line-height:13px;">' + strip(list_item.querySelector('.text-content').innerText) + '</span>';
            } else {
              html_code += '<span class="list-item" style="font-size:10px;display:block;line-height:13px;">' + strip(list_item.innerText) + '</span>';
            }
          }
        });
      });
    }
  
    
  
    if (spec_list_items) {
      html_code += '</br>';
      spec_list_items.forEach( spec_list => {
        // console.log('spec_list', spec_list);
        html_code += '<h5 class="heading" style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;text-transform:capitalize;">' + spec_list.closest('.spec-wrapper').querySelector('.heading').textContent + ':</h5>';
        spec_list.querySelectorAll('li').forEach( list_item => {
          html_code += '<span class="list-item" style="font-size:10px;display:block;line-height:13px;">' + list_item.innerText + '</span>';
        });
        
      });
    }
  
  
    if (spec_table_rows) {
      html_code += '</br>';
      html_code += '<h5 class="heading" style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;">Product Specifications: </h5>';
      spec_table_rows.forEach(row => {
        let rowLabel = row.querySelectorAll('.spec-label')[0].innerText;
        let rowContent = row.querySelectorAll('.spec-value')[0] ? row.querySelectorAll('.spec-value')[0].innerText : '';
        
        // let rowContent = row.querySelectorAll('.spec-value')[0] ? row.querySelectorAll('.spec-value')[0].filter(item => !item.querySelector("style").textContent ) : '';
        if (rowLabel && rowContent) {
          html_code += '<div style="line-height:13px;"><span class="label" style="line-height:13px;font-size:10px;color:#677279;">' + rowLabel + ': &nbsp;&nbsp;</span>' 
                    + '<span class="row-content" style="padding-left:5px;font-size:10px;font-weight:bold;"> ' + rowContent + '&nbsp;</span></div>';
        } else {
           html_code += '<div style="line-height:13px;"><span class="label" style="line-height:13px;font-size:10px;">' + rowLabel.replaceAll('.circle-bg{fill:#2f734f;}').replaceAll('.circle-check{fill:#FFF;}').replaceAll('undefined', '').replaceAll('.circle-bg{fill:var(--heading-color);}', '') + '</span></div>';
        }
      });
    }
  
  
    
    
    // END Container Div
  
    if (product_description) {
      html_code += '</br>';
      html_code += ''
      +    '<div style="">'
      +    '<h5 class="heading" style="margin-top:6px;font-size:12px;font-weight:bold;line-height:16px;">Description: </h5>'
      +    '<div><span style="text-align:left;padding-right:20px;line-height:13px;font-size:10px;">' + strip(product_description.innerText.replace('\n', '').trim()) + '</span></div>'
      +    '</div>';
    }
      
    // html_code += '</br></br></br></br></br></br></br></br></br></br></br></br>'
    //           + '<span style="text-align:center;color:white;width:100%;font-size:12px;">'+footer+'</span>';
  
    // Close main container div
    html_code += '</div>';
  
    // console.log('html_code', html_code);
    
    
    doc.setProperties({
      title: product_title.innerText /* Insert the  Product Title here*/
    });
  
  
  
  
    
  
    var img = new Image();
    img.src = product_template;
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = function () {
        /*image completely converted to base64string */
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        // var dataURL;
        canvas.height = this.height;
        canvas.width = this.width;
        ctx.drawImage(this, 0, 0);
        // dataURL = canvas.toDataURL(outputFormat);
  
        // /* call back function */
        // callback(dataURL);
        doc.addImage(img, "PNG", 0, 0, 211, 300);
        
  
      
        doc.fromHTML(html_code,
          15,
          15, 
          {'width': 176},
          function() {
            // window.open(URL.createObjectURL(doc.output("blob")));
            doc.save(product_title.textContent + '.pdf');
        });
      
    };
  
};
  
  
  
  // Loads an image (CORS-enabled) and resolves { dataURL, width, height }, or null on failure
function loadImageForPDF(src){
    return new Promise(function(resolve){
      if (!src) { resolve(null); return; }
      var img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = function(){
        try {
          var canvas = document.createElement('CANVAS');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext('2d').drawImage(img, 0, 0);
          resolve({ dataURL: canvas.toDataURL('image/png'), width: img.naturalWidth, height: img.naturalHeight });
        } catch (e) { resolve(null); }
      };
      img.onerror = function(){ resolve(null); };
      img.src = src;
    });
}
  
  // TEST VERSION: datasheet-style layout (header rule, image + detail table, divider, card grid).
  // Same data and colors as htmlToPDFFlyer, drawn with jsPDF primitives instead of fromHTML.
async function htmlToPDFFlyerV2(){
    var doc = new jsPDF();
    var footer = 'willygoat.com | fun@willygoat.com | 888-920-4628';
    var today = new Date();
    today = String(today.getMonth() + 1).padStart(2, '0') + '/' + String(today.getDate()).padStart(2, '0') + '/' + today.getFullYear();
  
    // Palette (from original flyer)
    var GREEN = [49, 120, 83], GRAY = [103, 114, 121], BORDER = [213, 215, 217], LIGHT = [247, 248, 248], RED = [220, 0, 0], BLACK = [0, 0, 0];
    var PAGE_W = 210, 
        PAGE_H = 297, 
        MARGIN = 15, 
        CONTENT_W = PAGE_W - MARGIN * 2;
    var USE_TEMPLATE = false;            // set false for a plain white page
    var TOP = USE_TEMPLATE ? 40 : 15;   // first-page content start (clears template header)
    var BOTTOM = 278;
    var product_template = "https://cdn.shopify.com/s/files/1/0100/6072/6369/files/Sell_Sheet_Template7.png?v=1757090669";
  
    var clean = function(t){ return (t || '').replace(/\.[\w-]+\{[^}]*\}/g, '').replace(/\s+/g, ' ').trim(); };
    var priceText = function(el){
      if (!el) return '';
      var c = el.cloneNode(true);
      c.querySelectorAll('.visually-hidden').forEach(function(n){ n.remove(); });
      return clean(c.textContent);
    };
  
    // ---------- Gather data (same sources as htmlToPDFFlyer) ----------
    var product_image = document.querySelector(".product-gallery__image");
    var product_title = document.querySelector(".product-meta__title");
    var product_vendor = document.querySelector(".product-meta__vendor");
    var product_description = document.querySelector(".description-above > p");
    var product_specification = document.querySelector("#unique-tab-product_specs");
    var features_list_items = document.querySelectorAll('#unique-tab-features .tab-list:not(#play-events-list)');
    var play_events_rows = document.querySelectorAll('#play-events-list li');
    var sale_price = priceText(document.querySelector(".product-form__info-item .price--highlight"));
    var regular_price = priceText(document.querySelector(".product-form__info-item .price--compare"));
    var regular_price_solo = priceText(document.querySelector('.product-form__info-content .price '));
  
    var title = clean(product_title ? product_title.textContent : 'Product');
  
    var details = []; // [label, value, opts]
    if (product_vendor) details.push(['Brand', clean(product_vendor.textContent)]);
    if (regular_price) details.push(['Regular Price', regular_price, { strike: true }]);
    if (sale_price) details.push(['Sale Price', sale_price, { bold: true, labelColor: RED }]);
    else if (regular_price_solo) details.push(['Price', regular_price_solo, { bold: true, labelColor: RED }]);
  
    var cards = []; // { title, lines[] }
    if (play_events_rows.length) {
      cards.push({ title: 'Play Events', lines: Array.prototype.map.call(play_events_rows, function(r){ return clean(r.textContent); }) });
    }
    features_list_items.forEach(function(feature_list){
      var heading = 'Features';
      if (feature_list.previousElementSibling) {
        heading = clean(strip(feature_list.previousElementSibling.innerText));
      } else if (feature_list.classList.contains('expandable-content')) {
        heading = clean(strip(feature_list.closest('.list-expandable-wrapper').previousElementSibling.textContent));
      }
      var lines = [];
      feature_list.querySelectorAll('li').forEach(function(li){
        var t;
        if (li.classList.contains('tab-icon') && !li.querySelector('.recycled') && li.querySelector('.shade-cert')) {
          t = strip(li.querySelector('.shade-cert').textContent);
        } else if (li.querySelector('.text-content')) {
          t = strip(li.querySelector('.text-content').innerText);
        } else {
          t = strip(li.innerText);
        }
        t = clean(t);
        if (t) lines.push(t);
      });
      if (lines.length) cards.push({ title: heading, lines: lines });
    });
    if (product_specification) {
      product_specification.querySelectorAll('.tab-list:not(.secondary-list)').forEach(function(spec_list){
        var wrapper = spec_list.closest('.spec-wrapper');
        var h = wrapper && wrapper.querySelector('.heading');
        var lines = [];
        spec_list.querySelectorAll('li').forEach(function(li){ var t = clean(li.innerText); if (t) lines.push(t); });
        if (lines.length) cards.push({ title: h ? clean(h.textContent) : 'Specifications', lines: lines });
      });
    }
  
    var spec_rows = []; // [label, value]
    if (product_specification) {
      var spec_table = product_specification.querySelector('.spec-table');
      if (spec_table) {
        spec_table.querySelectorAll('tr').forEach(function(row){
          var l = row.querySelector('.spec-label'), v = row.querySelector('.spec-value');
          var label = l ? clean(l.innerText) : '', value = v ? clean(v.innerText) : '';
          if (label) spec_rows.push([label, value]);
        });
      }
    }
  
    var description = product_description ? clean(strip(product_description.innerText)) : '';
  
    // ---------- Images ----------
    var templateImg = USE_TEMPLATE ? await loadImageForPDF(product_template) : null;
    var mainImg = product_image ? await loadImageForPDF(product_image.src) : null;
  
    // ---------- Drawing helpers ----------
    var y = TOP;
    var pageNum = 1;
    var setColor = function(c){ doc.setTextColor(c[0], c[1], c[2]); };
    var drawPageBase = function(){
      if (templateImg) doc.addImage(templateImg.dataURL, 'PNG', 0, 0, PAGE_W, PAGE_H);
      // footer
      doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]); doc.setLineWidth(0.3);
      doc.line(MARGIN, 285, PAGE_W - MARGIN, 285);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8); setColor(GRAY);
      doc.text(footer, PAGE_W / 2, 290, { align: 'center' });
    };
    var newPage = function(){
      doc.addPage(); pageNum++; drawPageBase(); y = 20;
    };
    var ensure = function(h){ if (y + h > BOTTOM) newPage(); };
    var sectionHeading = function(text){
      ensure(14);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(12); setColor(GREEN);
      doc.text(text, MARGIN, y + 4);
      y += 9;
    };
  
    drawPageBase();
  
    // ---------- Header ----------
    doc.setDrawColor(GREEN[0], GREEN[1], GREEN[2]); doc.setLineWidth(0.8);
    doc.line(MARGIN, y, PAGE_W - MARGIN, y);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9); setColor(GRAY);
    doc.text('PRODUCT FLYER', MARGIN, y + 7);
    doc.text('As of: ' + today, PAGE_W - MARGIN, y + 7, { align: 'right' });
    y += 20;
  
    doc.setFont('helvetica', 'bold'); doc.setFontSize(20); setColor(GREEN);
    var titleLines = doc.splitTextToSize(title, CONTENT_W);
    doc.text(titleLines, MARGIN, y);
    y += titleLines.length * 8;
  
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold'); setColor(GRAY);
    var urlLabel = 'Product URL: ';
    doc.text(urlLabel, MARGIN, y);
    doc.setFont('helvetica', 'normal');
    var urlText = doc.splitTextToSize(window.location.host + window.location.pathname, CONTENT_W - doc.getTextWidth(urlLabel) - 2);
    doc.text(urlText[0], MARGIN + doc.getTextWidth(urlLabel) + 1, y);
    y += 7;
  
    // ---------- Image box + details table ----------
    var boxW = 78, boxH = 78, boxTop = y;
    doc.setFillColor(LIGHT[0], LIGHT[1], LIGHT[2]);
    doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]); doc.setLineWidth(0.3);
    doc.roundedRect(MARGIN, boxTop, boxW, boxH, 1, 1, 'FD');
    doc.setFillColor(255, 255, 255);
    doc.rect(MARGIN + 4, boxTop + 4, boxW - 8, boxH - 8, 'FD');
    if (mainImg) {
      var maxW = boxW - 12, maxH = boxH - 12;
      var ratio = Math.min(maxW / mainImg.width, maxH / mainImg.height);
      var iw = mainImg.width * ratio, ih = mainImg.height * ratio;
      doc.addImage(mainImg.dataURL, 'PNG', MARGIN + (boxW - iw) / 2, boxTop + (boxH - ih) / 2, iw, ih);
    }
  
    var tx = MARGIN + boxW + 8, tw = PAGE_W - MARGIN - tx, labelW = 34, rowH = 10;
    doc.setFont('helvetica', 'bold'); doc.setFontSize(12); setColor(GREEN);
    doc.text('Product Details', tx, boxTop + 5);
    var ty = boxTop + 9;
    details.forEach(function(d){
      var opts = d[2] || {};
      doc.setFillColor(LIGHT[0], LIGHT[1], LIGHT[2]);
      doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]);
      doc.rect(tx, ty, labelW, rowH, 'FD');
      doc.rect(tx + labelW, ty, tw - labelW, rowH, 'S');
      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold'); setColor(opts.labelColor || GRAY);
      doc.text(d[0], tx + 3, ty + 6.3);
      doc.setFont('helvetica', opts.bold ? 'bold' : 'normal'); setColor(opts.bold ? BLACK : GRAY);
      var v = doc.splitTextToSize(d[1], tw - labelW - 6)[0];
      doc.text(v, tx + labelW + 3, ty + 6.3);
      if (opts.strike) {
        var w = doc.getTextWidth(v);
        doc.setDrawColor(GRAY[0], GRAY[1], GRAY[2]);
        doc.line(tx + labelW + 3, ty + 5.3, tx + labelW + 3 + w, ty + 5.3);
      }
      ty += rowH;
    });
  
    y = boxTop + boxH + 8;
    doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]); doc.setLineWidth(0.4);
    doc.line(MARGIN, y, PAGE_W - MARGIN, y);
    y += 8;
  
    // ---------- Description ----------
    if (description) {
      sectionHeading('Description');
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5); setColor(GRAY);
      doc.splitTextToSize(description, CONTENT_W).forEach(function(line){
        ensure(5); doc.text(line, MARGIN, y); y += 4.8;
      });
      y += 5;
    }
  
    // ---------- Specification table ----------
    if (spec_rows.length) {
      sectionHeading('Product Specifications');
      var sLabelW = 55;
      spec_rows.forEach(function(r, i){
        doc.setFontSize(9);
        var valLines = r[1] ? doc.splitTextToSize(r[1], CONTENT_W - sLabelW - 6) : [];
        var lblLines = doc.splitTextToSize(r[0], (r[1] ? sLabelW : CONTENT_W) - 6);
        var h = Math.max(valLines.length, lblLines.length) * 4.4 + 4;
        ensure(h);
        doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]); doc.setLineWidth(0.3);
        if (r[1]) {
          doc.setFillColor(LIGHT[0], LIGHT[1], LIGHT[2]);
          doc.rect(MARGIN, y, sLabelW, h, 'FD');
          doc.rect(MARGIN + sLabelW, y, CONTENT_W - sLabelW, h, 'S');
          doc.setFont('helvetica', 'bold'); setColor(GRAY);
          doc.text(lblLines, MARGIN + 3, y + 5);
          doc.setFont('helvetica', 'normal'); setColor(BLACK);
          doc.text(valLines, MARGIN + sLabelW + 3, y + 5);
        } else {
          doc.setFillColor(LIGHT[0], LIGHT[1], LIGHT[2]);
          doc.rect(MARGIN, y, CONTENT_W, h, 'FD');
          doc.setFont('helvetica', 'normal'); setColor(GRAY);
          doc.text(lblLines, MARGIN + 3, y + 5);
        }
        y += h;
      });
      y += 8;
    }
  
    // ---------- Card grid (features / play events / spec lists) ----------
    if (cards.length) {
      sectionHeading('Features');
      var gap = 5, cardW = (CONTENT_W - gap) / 2, lineH = 4.4;
      doc.setFontSize(9);
      cards.forEach(function(c){
        c.wrapped = [];
        c.lines.forEach(function(t){ c.wrapped.push(doc.splitTextToSize(t, cardW - 12)); });
        var n = c.wrapped.reduce(function(a, w){ return a + w.length; }, 0);
        c.h = 14 + n * lineH + c.wrapped.length * 1.2 + 3;
      });
      var drawCard = function(c, x, top){
        doc.setFillColor(LIGHT[0], LIGHT[1], LIGHT[2]);
        doc.setDrawColor(BORDER[0], BORDER[1], BORDER[2]); doc.setLineWidth(0.3);
        doc.roundedRect(x, top, cardW, c.h, 1, 1, 'FD');
        doc.setFont('helvetica', 'bold'); doc.setFontSize(10); setColor(GREEN);
        doc.text(c.title, x + 5, top + 7);
        doc.line(x + 5, top + 9.5, x + cardW - 5, top + 9.5);
        var cy = top + 15;
        doc.setFont('helvetica', 'normal'); doc.setFontSize(9); setColor(GRAY);
        c.wrapped.forEach(function(w){
          doc.text('•', x + 5, cy);
          doc.text(w, x + 9, cy);
          cy += w.length * lineH + 1.2;
        });
      };
      for (var i = 0; i < cards.length; i += 2) {
        var pair = cards.slice(i, i + 2);
        var rowHt = Math.max.apply(null, pair.map(function(c){ return c.h; }));
        ensure(rowHt);
        pair.forEach(function(c, j){ c.h = rowHt; drawCard(c, MARGIN + j * (cardW + gap), y); });
        y += rowHt + gap;
      }
    }
  
    doc.setProperties({ title: title });
    doc.save(title + '.pdf');
}
  